import { SelectItem } from "primeng/api";

enum DuplicatePatientCheckType {
    None,
    FirstLetterDOBMatch,
    FuzzyName,
    FirstLetterDOBMatchAndFuzzyName
}

const DuplicatePatientCheckTypeMap: Record<DuplicatePatientCheckType, string> = {
    0: "None",
    1: "First Letter/DOB Match",
    2: "Fuzzy Name",
    3: "Match Both (First Letter/DOB Match & Fuzzy Name)"
};

function createOptions() {
    return Object.keys(DuplicatePatientCheckTypeMap)
        .map(k => +k as DuplicatePatientCheckType)
        .map(k => <SelectItem>{ value: k, label: DuplicatePatientCheckTypeMap[k] });
}

export { DuplicatePatientCheckType, DuplicatePatientCheckTypeMap, createOptions };
